const roundPrice = (number) => {
  return Math.ceil(number);
};

export default roundPrice;
